import { PageLink, PageTitle } from "_metronic/layout/core"
import { MinutaImport } from "app/pages/minutas/minutaImport/MinutaImport"
import ExcelToJsonConverter from "app/services/excelToJson/ExcelToJsonConverter"
import { Route, Routes } from "react-router-dom"
const importBreadCrumbs: Array<PageLink> = [
    {
      title: 'Soporte',
      path: '/support/import-excel/import-excel.page',
      isSeparator: false,
      isActive: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: true,
    },
  ]
export const ImportPage = () => {
    return (
      <>
        <Routes>
            <Route
              path='import-excel'
              element={
                <>
                  <PageTitle breadcrumbs={importBreadCrumbs}>Importar contrato</PageTitle>
                  <ExcelToJsonConverter />
                </>
              }
            />
        </Routes>
      </>
    )
  }